import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import React, { useState} from 'react';
import { Controller } from 'react-hook-form';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Checkbox from '@mui/material/Checkbox';

/**
 * 入力チェック用チェックボックスドロップダウンリスト Component
 * 2025.3.5 MyMine Version2.1対応 Add 
 */
const ValidatableCheckBoxDropDownList = ({ control, name, options, defaultValue, needsBlank, rules, formState, onChange, disabled, maxWidth, placeholder, sx, blankValue, value, ...other }) => {
  const [selectOptions, setSelectOptions] = useState([]);
  const [checkedValue, setCheckedValue] = useState(defaultValue ?? []);
  const onChangeValue = (e) => {
    var targetValue = e.target.value.map(x => Number(x));
    const duplValue = targetValue.filter(function (x, i, self) {
      return self.indexOf(x) === i && i !== self.lastIndexOf(x);
    });
    targetValue = targetValue.filter(i => duplValue.indexOf(i) === -1);

    const selectedValue = [];
    const selectedText = [];
    for (let i = 0; i < options.length; i++) {
      if (typeof options[i].value === "undefined") {
        //Key,Valueの場合
        if (targetValue.some(element => element === options[i].Key)) {
          selectedText.push(options[i].Value);
          selectedValue.push(options[i].Key);
        }
      } else {
        //value,textの場合
        if (targetValue.some(element => element === options[i].value)) {
          selectedText.push(options[i].text);
          selectedValue.push(options[i].value);
        }
      }
    }
    setSelectOptions(selectedText);
    setCheckedValue(selectedValue);
    onChange(selectedValue);
  };

  const onSetDefaultValue = (defaultValue) => {
    const selectedText = [];
    for (let i = 0; i < options.length; i++) {
      if (defaultValue.some(element => element === options[i].Key)) {
        selectedText.push(options[i].Value);
      }
    }
    return selectedText.join(', ');
  }


  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? ''}
      render={({ field: { ref, ...field } }) =>
        <FormControl error={formState.errors[name] ? true : false} sx={maxWidth && { width: '100%' }}>
          {placeholder && <InputLabel sx={{ marginTop: '-5px', color: 'rgba(0, 0, 0, 0.6) !important' }}>{placeholder}</InputLabel>}
          <Select
            sx={{
              height: 40,
              ...sx
            }}
            onChange={onChangeValue}
            value={value}
            renderValue={(selected) => selectOptions.length > 0 ? selectOptions.join(', ') : onSetDefaultValue(defaultValue)}
            {...other}
          >
            {needsBlank && <MenuItem sx={{ height: 30, }} key={-1} value=''>{blankValue ?? ''}</MenuItem>}
            {options.map((option) => {
              const isKeyValue = option.Key !== undefined;
              return (
                <MenuItem
                  key={isKeyValue ? option.Key : option.value}
                  value={isKeyValue ? option.Key : option.value}>
                  <Checkbox checked={checkedValue.includes(isKeyValue ? option.Key : option.value)} />
                  {isKeyValue ? option.Value : option.text}
                </MenuItem>)

            })
            }
          </Select>
          <FormHelperText>{!disabled && formState.errors[name]?.message}</FormHelperText>
        </FormControl>
      }
      rules={rules}
    />
  );
};
export default ValidatableCheckBoxDropDownList;
